import {Pipe, PipeTransform} from '@angular/core';
import {TranslocoPipe} from "@ngneat/transloco";
import {FreightDocumentRoleEnum} from "../../../core/models/freight-document/FreightDocumentRoleEnum";
import {Comment} from "../../../core/models/freight-document/Comment";

@Pipe({
  name: 'commentRole',
})
export class CommentRolePipe implements PipeTransform {
  constructor(private translocoPipe: TranslocoPipe) {}

  transform(comment: Comment): string {
    const creatorRole:string = comment.creatorRole;
    if (creatorRole && creatorRole != FreightDocumentRoleEnum.CARRIER_ACCESS_CODE) {
      return ' (' + this.translocoPipe.transform('role.' + creatorRole.toLocaleLowerCase()) + ')';
    } else {
      return '';
    }
  }
}
